import React from "react";
import {Form} from "./Form";
import {FormInput} from "./FormInput";
import {FormSubmit} from "./FormSubmit";
import {FormTextArea} from "./FormTextArea";
import {FormCheckBox} from "./FormCheckBox";
import { FormInitValuesType, FormChildrenParamType, FormParams, FormInputParams, FormSubmitType } from "./types";

export type { FormInitValuesType, FormChildrenParamType, FormParams, FormInputParams, FormSubmitType };

export default Object.assign(Form, {
    Input: FormInput,
    TextArea: FormTextArea,
    Submit: FormSubmit,
    CheckBox: FormCheckBox
})